<template>
  <div class="app-wrapper" :class="{ 'is-ipad': isIpad }">
    <Sidebar />
    <div class="main-body">
      <Navbar />
      <AppMain />
    </div>
  </div>
</template>
<script lang="ts" setup>
import AppMain from './components/AppMain.vue'
import Navbar from './components/Navbar.vue'
import Sidebar from './components/Sidebar/index.vue'
import { useDictStore } from '@/store/modules/dict'
import { usePermissionStore } from '@/store/modules/permission'
import { isEmpty } from '@/libs/utils/data-checker'
import { useStatisticsStore } from '@/store/modules/statistics'
import { getStatisticsStoreOptions } from '@/api/stat'
const statisticsStore = useStatisticsStore()
const permissionStore = usePermissionStore()
const dictStore = useDictStore()
const isIpad = window.isIpad

const initDeptOptions = async () => {
  try {
    const res = await getStatisticsStoreOptions()
    if (res.code === 0) {
      statisticsStore.setStoreOptions(res.data ?? [])
    }
  } finally {
    statisticsStore.markStoreOptionsReady()
  }
}

onBeforeMount(() => {
  dictStore.setAreaTree()
  initDeptOptions()
})
</script>
<style lang="scss" scoped>
.app-wrapper {
  display: flex;
  width: 100%;
  height: 100%;
  background-color: var(--defalut-bgc);
  box-sizing: border-box;
}

.main-body {
  width: calc(100% - 102px);
  flex: 1;
  height: 100%;
}

.app-wrapper.is-ipad {
  .main-body {
    width: calc(100% - 64px);
  }
}
</style>
